import { select, call } from 'redux-saga/effects';
import { scrollToTop } from 'redux/saga/helpers';
import { isLoggedIn } from 'redux/saga/selectors';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { memberStatus } from 'enums/memberStatus';

// redirects to the purchase URL for this item if you are already logged in
export function* signupOnEnterSaga(client, nextState, replaceState) {
  const loggedIn = yield select(isLoggedIn);
  if (loggedIn) {
    yield call(replaceState, {
      ...nextState.location,
      pathname: nextState.location.pathname.replace(/^\/signup/, '/purchase'),
    });
  }
  yield call(scrollToTop);
}

export function* cartAbandonerOnEnterSaga(client, nextState, replaceState) {
  const loggedIn = yield select(isLoggedIn);
  if (!loggedIn) {
    return yield call(replaceState, '/');
  }
  yield call(requireMembershipSaga, client, replaceState, [memberStatus('UNSUBSCRIBED')]);
  yield call(scrollToTop);
}
